// extracted by mini-css-extract-plugin
export default {"control":"EmbedWidthControl_control__b8Tfa","value":"EmbedWidthControl_value__Iw2-n","slider":"EmbedWidthControl_slider__D4SDU","bounds":"EmbedWidthControl_bounds__Y63Fk"};